// Metadata and UI helpers only. Question generators stay in the Worker.
import type {Course,Problem} from './types';
export interface BrowserTopic {
  id:string;name:string;unit:string;prereqs:string[];
  points:{name:string;idea?:string;pitfalls?:string[]}[];
  encompasses?:Record<string,number>;diagnosticKey?:boolean;
}
export interface BrowserCourse {
  id:Course;name:string;topics:BrowserTopic[];
  units:{name:string;topics:number;points:number}[];
  coverage:{strand:string;standards:string;topics:string[];scope:string}[];
}
export interface ContentCatalog {contentVersion:string;courses:BrowserCourse[]}
export interface BrowserQuestions {course:Course;topic:string;point:number;start:number;next:number;measurementSystem:'us'|'metric';questions:Problem[]}
export const BROWSER_PAGE_SIZE=25;
export const QUESTION_BATCH_SIZE=3;
export function filterBrowserTopics(course:BrowserCourse,unit:string,search:string) {
  const terms=search.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
  return course.topics.filter(t=>(unit==='all'||t.unit===unit)&&terms.every(term=>[t.id,t.name,t.unit,...t.points.map(p=>p.name)].join(' ').toLocaleLowerCase().includes(term)));
}
export function groupBrowserUnits(topics:BrowserTopic[]):BrowserCourse['units'] {
  const units=new Map<string,{name:string;topics:number;points:number}>();
  for(const topic of topics){const row=units.get(topic.unit)??{name:topic.unit,topics:0,points:0};row.topics++;row.points+=topic.points.length;units.set(topic.unit,row);}
  return [...units.values()];
}
export interface BrowserSelection {course:string;topic:string;point:number;start:number;measurementSystem:'us'|'metric'}
const uint=(s:string|null,fallback=0)=>s!==null&&/^(0|[1-9]\d*)$/.test(s)&&Number(s)<=0xffffffff?Number(s):fallback;
export function readBrowserSelection(search:string):BrowserSelection {
  const p=new URLSearchParams(search);
  return {course:p.get('course')??'algebra',topic:p.get('topic')??'',point:Math.min(3,uint(p.get('point'))),start:uint(p.get('sample')),measurementSystem:p.get('units')==='metric'?'metric':'us'};
}
export function browserSelectionQuery(s:BrowserSelection) {
  return new URLSearchParams({admin:'curriculum',course:s.course,topic:s.topic,point:String(s.point),sample:String(s.start),units:s.measurementSystem}).toString();
}

export function browserQuestionsMatch(data:BrowserQuestions|null,s:BrowserSelection) {
  return !!data&&data.course===s.course&&data.topic===s.topic&&data.point===s.point&&data.start===s.start&&data.measurementSystem===s.measurementSystem;
}
export function leaveBrowserQuery(search:string) {
  const p=new URLSearchParams(search);
  if(p.get('admin')==='curriculum')for(const key of ['admin','course','topic','point','sample','units'])p.delete(key);
  return p.toString();
}
